import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import IPaginations from "../../../components/paginations.vue";
import { domainName, processFile } from "../../../utility/index"

export default {
    name: "FaceAuthorize",
    components: { tree, iTable, IPagination, IPaginations },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                terminalId: '',
                linkState: '',
                authorizeCountUpper: 300,
                authorizeCountLower: 0
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "customNum",
                    label: this.$t('common.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",
                    width: "160px"

                },
                {
                    prop: "messageTime",
                    label: this.$t('common.messageTime'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "linkState",
                    label: this.$t('common.linkState'),
                    align: "center",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.linkState == 1 ? 'success' : 'danger' }
                        }, params.row.linkState == 1 ? this.$t('common.onLine')  : this.$t('common.offLine') )
                    }

                },
                {
                    prop: "faceAuthorizeCount",
                    label: this.$t('DriverManagement.authorizes') ,
                    align: "center",
                    width: "150px"
                },

            ],
            dialogOperateFormVisible: false,
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            this.terminalId = row.terminalId
                            this.dialogOperateFormVisible = true
                            this.authorizeColumns = this.authorizedPersonColumns;
                            this.getOperateList()
                        }
                    }
                ],
            },
            input: '',
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
            dialogFormVisible: false,
            formLabelWidth: '112px',
            rules: {
                driverNum: [
                    { required: true, message: this.$t('common.form.dirver') , trigger: 'change' }
                ],
            },
            form: {
                terminalId: '',
                driverNum: ''
            },
            driveList: [],
            selected: [],
            dialogSyncFormVisible: false,
            bathchRules: {
                fingerGroupId: [
                    { required: true, message: this.$t('common.form.group') , trigger: 'change' }
                ],
            },
            batchForm: {
                terminalId: '',
                fingerGroupId: ''
            },
            fingerList: [],
            formTable: {
                driverNum: '',
                driverName: ''
            },
            authorizedPersonColumns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",

                },
                {
                    prop: "driverName",
                    label: this.$t('common.driverName'),
                    align: "center",
                    width: "120px"
                },
                // {
                //     prop: "authorizePowerStr",
                //     label: this.$t('DriverManagement.authorizeType'),
                //     align: "center",
                //     width: "120px"
                // },
                {
                    prop: "createTime",
                    label: this.$t('DriverManagement.authorizationTime'),
                    align: "center",
                },
            ],
            operationLogColumns: [
                // {
                //     prop: "carId",
                //     label: this.$t('common.carId'),
                //     align: "center",
                // },
                // {
                //     prop: "terminalId",
                //     label: this.$t('common.terminalId'),
                //     align: "center",
                //     width: "140px"
                // },
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",

                },
                {
                    prop: "driverName",
                    label: this.$t('common.driverName'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "operationTypeStr",
                    label: this.$t('DriverManagement.operatType'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "lastUser",
                    label: this.$t('DriverManagement.operator'),
                    align: "center",
                },
                {
                    prop: "createTime",
                    label: this.$t('DriverManagement.operatTime'),
                    align: "center",
                },
            ],
            authorizeList: [],
            authorizeHeight: '350px',
            authorizeColumns: [
                
            ],
            authorizeOperates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            AuthorizeCurrentPage: 1, 
            AuthorizePageSize: 50, 
            AuthorizeTotal: 1, 
            terminalId: '',
            select: [],
            driverName: '',
            fingerGroupName: '',
            activeName: "first",
        }
    },
    created() {
        
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getAuthorizaList()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getAuthorizaList()
        },
        getAuthorizaList() {
            let param = {
                orgId: this.id,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                terminalId: this.formInline.terminalId,
                linkState: this.formInline.linkState,
                authorizeCountUpper: this.formInline.authorizeCountUpper,
                authorizeCountLower: this.formInline.authorizeCountLower,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('FaceAuthorize/GET_SELECTFACEAUTHORIZE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        filterMethod(val) {
            this.driverName = val
            this.getDriveList()
        },
        getDriveList() {
            let param = {
                orgId: this.id,
                name: this.driverName,
                pageNum: 1,
                pageSize: 10000,
            }
            this.$store.dispatch('DriverFile/GET_SELECTALLDRIVER', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.driveList = res.data.data.list
                    }
                }
            }).catch(err => { })
        },
        filterFingerMethod(val) {
            this.fingerGroupName = val
            this.getFingerList()
        },
        getFingerList() {
            let param = {
                orgId: this.id,
                fingerGroupName: this.fingerGroupName
            }
            this.$store.dispatch('FingerprintAuthorization/GET_SELECTCARFINGERWAREHOUSE', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.fingerList = res.data.data
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAuthorizaList()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                terminalId: '',
                linkState: '',
                authorizeCountUpper: 300,
                authorizeCountLower: 0
            }
            this.getAuthorizaList()
        },
        addAuthorize() {
            this.dialogFormVisible = true
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                this.form.terminalId = this.selected[0].terminalId
            })
            this.getDriveList()
        },
        submitAddAuthorize(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        terminalId: this.form.terminalId,
                        driverNum: this.form.driverNum
                    }
                    this.$store.dispatch('FaceAuthorize/GET_INSERTAUTHORIZE', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.addSuccess'))
                            this.dialogFormVisible = false;
                            this.getAuthorizaList();
                            this.closeDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })


                } else {
                    return false;
                }
            });
        },
        cancel(formName) {
            this.dialogFormVisible = false;
            this.form = {
                terminalId: '',
                driverNum: ''
            }
        },
        closeDia() {
            this.form = {
                terminalId: '',
                driverNum: ''
            }
            this.dialogFormVisible = false;
        },
        clearAuthorize() {
            this.$confirm(this.$t('common.btn.confirmClear'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = {
                        terminalId: this.selected[0].terminalId,
                    }
                    this.$store.dispatch('FaceAuthorize/GET_CLEARAUTHORIZE', param).then(response => {
                        if (response.data.code == 200) {
                            this.getAuthorizaList()
                            this.$message.success(this.$t('common.btn.clearSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        batchAuthorize() {
            this.dialogSyncFormVisible = true
            this.$nextTick(() => {
                this.$refs.batchForm.resetFields()
                this.batchForm.terminalId = this.selected[0].terminalId
            })
            this.getFingerList()
        },
        submitBatchAuthorize(batchForm) {
            this.$refs[batchForm].validate((valid) => {
                if (valid) {
                    let param = {
                        terminalId: this.batchForm.terminalId,
                        fingerGroupId: this.batchForm.fingerGroupId
                    }
                    this.$store.dispatch('FaceAuthorize/GET_INSERTFACEAUTHORIZE', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.authSuccess'))
                            this.dialogSyncFormVisible = false;
                            this.getAuthorizaList();
                            this.closeBatchAuthorize();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })


                } else {
                    return false;
                }
            });
        },
        cancelBatchAuthorize(SyncFormName) {
            this.dialogSyncFormVisible = false;
            this.SyncForm = {
                terminalId: '',
                fingerGroupId: ''
            }
        },
        closeBatchAuthorize() {
            this.SyncForm = {
                terminalId: '',
                fingerGroupId: ''
            }
            this.dialogSyncFormVisible = false;
        },
        download() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportFaceAuthorize?orgId=${this.id}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&terminalId=${this.formInline.terminalId}&linkState=${this.formInline.linkState}&authorizeCountUpper=${this.formInline.authorizeCountUpper}&authorizeCountLower=${this.formInline.authorizeCountLower}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportFaceAuthorize?orgId=${this.id}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&terminalId=${this.formInline.terminalId}&linkState=${this.formInline.linkState}&authorizeCountUpper=${this.formInline.authorizeCountUpper}&authorizeCountLower=${this.formInline.authorizeCountLower}`
                    location.href = url
                }
            }
        },

        handleClick(event) {
            this.activeName = event.name;
            if (this.activeName == "first") {
                this.authorizeColumns = this.authorizedPersonColumns;
                this.formTable = {
                    driverNum: '',
                    driverName: ''
                }
            } else {
                this.authorizeColumns = this.operationLogColumns;
                this.formTable = {
                    driverNum: '',
                    driverName: ''
                }
            }
            this.getOperateList();
        },
        getOperateList() {
            if(this.activeName == 'first') {
                let param = {
                    terminalId: this.terminalId,
                    driverNum: this.formTable.driverNum,
                    driverName: this.formTable.driverName,
                    pageNum: this.AuthorizeCurrentPage,
                    pageSize: this.AuthorizePageSize,
                }
                this.$store.dispatch('FaceAuthorize/GET_SELECTFACEAUTHORIZERECORD', param).then(res => {
                    if (res) {
                        if (res.data.code == 200) {
                            this.authorizeList = res.data.data.list
                            this.$refs.AuthorizePage.CommandTotal = res.data.data.total
                        }
                    }
                }).catch(err => { })
            }else {
                let param = {
                    terminalId: this.terminalId,
                    driverNum: this.formTable.driverNum,
                    driverName: this.formTable.driverName,
                    pageNum: this.AuthorizeCurrentPage,
                    pageSize: this.AuthorizePageSize,
                }
                this.$store.dispatch('FaceAuthorize/GET_SELECTFACEAUTHORIZEOPERATION', param).then(res => {
                    if (res) {
                        if (res.data.code == 200) {
                            this.authorizeList = res.data.data.list
                            this.$refs.AuthorizePage.CommandTotal = res.data.data.total
                        }
                    }
                }).catch(err => { })
            }
            
        },
        closeOperateDia() {
            this.dialogOperateFormVisible = false
        },
        Search() {
            this.$refs.AuthorizePage.CommandCurrentPage = 1
            this.AuthorizeCurrentPage = 1
            this.getOperateList()
        },
        Clear() {
            this.formTable = {
                driverNum: '',
                driverName: ''
            },
                this.getOperateList()
        },
        handleAuthorizeChange(val) {
            this.select = val
        },
        changeAuthorizeSize(item) {
            this.AuthorizePageSize = item.pageSize
            this.AuthorizeCurrentPage = item.pageNum
            this.getOperateList();
        },
        batchDelete() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = {
                        terminalId: this.select[0].terminalId,
                        driverNum: this.select.map(item => item.driverNum).join()
                    }
                    this.$store.dispatch('FaceAuthorize/GET_DELETEICAUTHORIZE', param).then(response => {
                        if (response.data.code == 200) {
                            this.getOperateList()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },

        downloadRecord() {
            if(this.activeName == 'first') {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/exportFaceAuthorizeRecord?terminalId=${this.terminalId}&driverNum=${this.formTable.driverNum}&driverName=${this.formTable.driverName}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/exportTerminalAuthorizeRecord?terminalId=${this.terminalId}&driverNum=${this.formTable.driverNum}&driverName=${this.formTable.driverName}`
                        location.href = url
                    }
                }
            }else {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/exportFaceAuthorizeOperation?terminalId=${this.terminalId}&driverNum=${this.formTable.driverNum}&driverName=${this.formTable.driverName}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/exportFaceAuthorizeOperation?terminalId=${this.terminalId}&driverNum=${this.formTable.driverNum}&driverName=${this.formTable.driverName}`
                        location.href = url
                    }
                }
            }
        },

        handleSelectionChange(val) {
            console.log(val)
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAuthorizaList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}